import React, { useEffect } from 'react';
import { useTranslation } from 'react-i18next';
import { useNavigate } from 'react-router-dom';

export const Main: React.FC = () => {
	const {i18n} = useTranslation();
	const navigate = useNavigate();

	useEffect(() => {
		const locationArr = location.pathname.split('/');
		if (locationArr.length === 1 || !locationArr.length || location.pathname === '/') {
			navigate(`${i18n.language}/auth/sign-up/`);
		}
		if (!locationArr[1] || !locationArr[2]) {
			navigate(`${i18n.language}/auth/sign-up/`);
		}
	}, []);

	return <div>
		Main
	</div>;
};
